/**
 * userUtils.js — shared role + venue helpers
 * Import from any page: import { isAdminUser, isManagerUser, isSupervisorUser, getUserVenues, userCanAccessVenue } from '../userUtils';
 */

/** true only for admin */
export function isAdminUser(u)      { return u?.role === 'admin'; }

/** true for admin + manager */
export function isManagerUser(u)    { return u?.role === 'manager' || isAdminUser(u); }

/** true for admin + manager + supervisor */
export function isSupervisorUser(u) { return u?.role === 'supervisor' || isManagerUser(u); }

/** true for bar or kitchen staff */
export function isStaffRole(u)      { return u?.role === 'bar' || u?.role === 'kitchen'; }

/**
 * Returns the array of venues this user can access.
 * - admin            → [] (empty = all venues, check with isAdminUser separately)
 * - manager          → u.venues[] (multi-venue array from DB)
 * - supervisor/bar/kitchen → [u.venue] (single venue)
 * - Prep Kitchen     → ['Prep Kitchen']
 */
export function getUserVenues(u) {
  if (!u) return [];
  if (isAdminUser(u)) return [];                          // admin = unrestricted
  if (u.role === 'manager') return u.venues || [];        // multi-venue array
  return u.venue ? [u.venue] : [];                        // single venue
}

/**
 * Returns true if the user can access the given venue.
 * Admin always returns true.
 */
export function userCanAccessVenue(u, venue) {
  if (isAdminUser(u)) return true;
  const vv = getUserVenues(u);
  return vv.includes(venue);
}

/**
 * Returns a display string for the user's venue(s).
 * Used in the sidebar profile section.
 */
export function venueDisplayLabel(u) {
  if (!u) return '';
  if (isAdminUser(u)) return 'All Venues';
  if (u.role === 'manager') {
    const vv = u.venues || [];
    if (vv.length === 0) return 'No venues assigned';
    if (vv.length === 1) return vv[0];
    if (vv.length === 2) return vv.join(' · ');
    return `${vv[0]} +${vv.length - 1} more`;
  }
  return u.venue || '—';
}